import React, { useState } from "react";
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { useEditSupplierMutation } from "../../../features/api/supplierApi";

const UpdateSupplier = ({ supplier }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [s_name, setName] = useState("");
  const [s_email, setEmail] = useState("");
  const [s_address, setAddress] = useState("");
  const [s_phone, setPhone] = useState("");
  const [s_mobile, setMobile] = useState("");
  const [s_web, setWeb] = useState("");

  const [updateSupplier] = useEditSupplierMutation();
  const handleUpdate = async (id) => {
    try {
      const data = {
        id: id,
        s_name: s_name ? s_name : supplier?.s_name,
        s_email: s_email ? s_email : supplier?.s_email,
        s_address: s_address ? s_address : supplier?.s_address,
        s_phone: s_phone ? s_phone : supplier?.s_phone,
        s_mobile: s_mobile ? s_mobile : supplier?.s_mobile,
        s_web: s_web ? s_web : supplier?.s_web,
      };

      const response = await updateSupplier(data);
      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md md:w-[650px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Supplier Update</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-1 lg:gap-2 w-full">
                    <div className="flex justify-between">
                      <label className=" mr-5">Name:</label>
                      <input
                        type="text"
                        defaultValue={supplier?.s_name}
                        onChange={(e) => setName(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-5">Email:</label>
                      <input
                        type="text"
                        defaultValue={supplier?.s_email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-1">Address:</label>
                      <input
                        type="text"
                        defaultValue={supplier?.s_address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-4">Phone:</label>
                      <input
                        type="text"
                        defaultValue={supplier?.s_phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-4">Mobile:</label>
                      <input
                        type="text"
                        defaultValue={supplier?.s_mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-2">Website:</label>
                      <input
                        type="text"
                        defaultValue={supplier?.s_web}
                        onChange={(e) => setWeb(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => handleUpdate(supplier?.id)}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSupplier;
